/**
 * Detects if the app is running in an e2e test environment.
 * Works for both Playwright and Cypress without build-time configuration.
 *
 * - Cypress: Sets `window.Cypress` automatically
 * - Playwright: We inject `window.__PLAYWRIGHT_TEST__` via addInitScript in config
 */
export const isE2ETest = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  // Cypress automatically sets window.Cypress
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if ((window as any).Cypress) {
    return true;
  }

  // Playwright: we inject this via addInitScript in playwright.config.ts
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if ((window as any).__PLAYWRIGHT_TEST__) {
    return true;
  }

  return false;
};
